var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_dashboard",
    transform: "translate(61.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar_chart-24px",
    transform: "translate(6.000000, 18.000000) rotate(-270.000000) translate(-6.000000, -18.000000) translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 12 0 12 12 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,4.9 L3.41428571,4.9 C3.85428571,4.9 4.21428571,5.26 4.21428571,5.7 L4.21428571,9.7 C4.21428571,10.14 3.85428571,10.5 3.41428571,10.5 L3.3,10.5 C2.86,10.5 2.5,10.14 2.5,9.7 L2.5,5.7 C2.5,5.26 2.86,4.9 3.3,4.9 Z M6.5,2.5 C6.94,2.5 7.3,2.86 7.3,3.3 L7.3,9.7 C7.3,10.14 6.94,10.5 6.5,10.5 C6.06,10.5 5.7,10.14 5.7,9.7 L5.7,3.3 C5.7,2.86 6.06,2.5 6.5,2.5 Z M9.7,7.07142857 C10.14,7.07142857 10.5,7.43142857 10.5,7.87142857 L10.5,9.7 C10.5,10.14 10.14,10.5 9.7,10.5 C9.26,10.5 8.9,10.14 8.9,9.7 L8.9,7.87142857 C8.9,7.43142857 9.26,7.07142857 9.7,7.07142857 L9.7,7.07142857 Z",
    id: "Shape",
    fill: "#616674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaderboard-24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,10.5 L1.5,10.5 C1.225,10.5 1,10.275 1,10 L1,5 C1,4.725 1.225,4.5 1.5,4.5 L3.25,4.5 C3.525,4.5 3.75,4.725 3.75,5 L3.75,10 C3.75,10.275 3.525,10.5 3.25,10.5 Z M6.875,1.5 L5.125,1.5 C4.85,1.5 4.625,1.725 4.625,2 L4.625,10 C4.625,10.275 4.85,10.5 5.125,10.5 L6.875,10.5 C7.15,10.5 7.375,10.275 7.375,10 L7.375,2 C7.375,1.725 7.15,1.5 6.875,1.5 Z M10.5,5.5 L8.75,5.5 C8.475,5.5 8.25,5.725 8.25,6 L8.25,10 C8.25,10.275 8.475,10.5 8.75,10.5 L10.5,10.5 C10.775,10.5 11,10.275 11,10 L11,6 C11,5.725 10.775,5.5 10.5,5.5 Z",
    id: "Shape",
    fill: "#616674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pie_chart-24px",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 12 0 12 12 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,1.59 L5.5,10.41 C5.5,10.73 5.205,10.97 4.895,10.9 C2.66,10.4 1,8.395 1,6 C1,3.605 2.66,1.6 4.895,1.1 C5.205,1.03 5.5,1.27 5.5,1.59 Z M6.515,1.59 L6.515,4.995 C6.515,5.27 6.74,5.495 7.015,5.495 L10.41,5.495 C10.73,5.495 10.97,5.2 10.9,4.885 C10.475,3.005 9,1.525 7.125,1.1 C6.81,1.03 6.515,1.27 6.515,1.59 Z M6.515,7.005 L6.515,10.41 C6.515,10.73 6.81,10.97 7.125,10.9 C9.005,10.475 10.48,8.99 10.905,7.11 C10.975,6.8 10.73,6.5 10.415,6.5 L7.02,6.5 C6.74,6.505 6.515,6.73 6.515,7.005 Z",
    id: "Shape",
    fill: "#616674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "show_chart-24px",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 12 0 12 12 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13671358,9.13212598 L4.895267,6.37357256 L6.58683277,8.06513834 C6.80023029,8.27853586 7.14374827,8.26812623 7.34153134,8.04431907 L11.0733857,3.84403113 C11.2555543,3.64104324 11.2451447,3.32875418 11.0525664,3.1309711 C10.8443737,2.92277839 10.4956509,2.92798321 10.2978678,3.15179037 L6.97198928,6.88884952 L5.25960424,5.17646448 C5.05661635,4.97347659 4.72871283,4.97347659 4.52572493,5.17646448 L1.35599092,8.35140331 C1.15300303,8.55439121 1.15300303,8.88229472 1.35599092,9.08528262 L1.40283428,9.13212598 C1.60582217,9.33511387 1.93893051,9.33511387 2.13671358,9.13212598 Z",
    id: "Path",
    fill: "#616674"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.a9d134bf92859f3b630184c98350311a.svg";
export { ForwardRef as ReactComponent };